<template>
    <div class="row"
         v-if="application.cost > 0 && !['subdivision_no', 'sb_no', 'fsb_no', 'discard'].includes(application.status)">
        <div class="col-sm-4 col-xs-12 col-sm-offset-5 application-cost">
        <span v-if="archived !== 1 || application.paymentStatus === 'payment' && archived === 1">
            Стоимость услуг <b>{{ application.cost.toLocaleString('ru') }}&nbsp;руб.</b>&nbsp;с&nbsp;НДС
        </span>
        </div>
        <div class="col-sm-3 col-xs-3 text-right application-cost-status">
            <span v-if="application.paymentStatus === 'payment'">
                <b>Оплачено</b>
            </span>
            <span v-else-if="archived !== 1 && application.paymentStatus === 'waiting'">
              <b>Ожидает оплаты</b>
            </span>
            <span v-if="user && (user.role === 'trusted_user' || !user.role)">
              <a :href="baseUrl + '/profile/account#payment'">Оплатить</a>
            </span>
        </div>
    </div>
</template>

<script>

import MainMixin from '@/common/mixins/mainMixin'

export default {
  name: 'ApplicationItemCost',

  mixins: [MainMixin],

  props: {
    application: {
      type: Object
    },

    archived: {
      type: Number
    }
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL
    }
  }
}
</script>

<style scoped>

</style>
